(function () {
  var mq = window.matchMedia('(min-width: 590px)');

  document.addEventListener(
    'click',
    function (e) {
      if (!mq.matches) return;
      var thumb = e.target.closest('[data-product-thumb]');
      if (!thumb) return;
      var root = thumb.closest('.product__photos--stack');
      if (!root) return;
      var index = thumb.getAttribute('data-index');
      if (index == null) return;
      var item = root.querySelector('.product__stack-item[data-index="' + index + '"]');
      if (!item) return;
      item.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      e.preventDefault();
      e.stopPropagation();
    },
    true
  );
})();
